import axios from 'axios';
import { BASE_URL } from './api';

export const getUploadSignedUrl = (key, contentType) => {
    return axios.post(`${BASE_URL}/api/files/upload-file`, { key, contentType })
        .then(response => {
            if (response.data.status === 'success') {
                return response.data.url;
            } else {
                throw new Error('Failed to get upload signed URL');
            }
        })
        .catch(error => {
            console.error('Error getting upload signed URL:', error);
            throw error;
        });
};

export const getViewSignedUrl = (key) => {
    return axios.post(`${BASE_URL}/api/files/get-file-url`, { key })
        .then(response => {
            if (response.data.status === 'success') {
                return response.data.url;
            } else {
                throw new Error('Failed to get view signed URL');
            }
        })
        .catch(error => {
            console.error('Error getting view signed URL:', error);
            throw error;
        });
};


